import utils from '../../../common/utils'
import api from '../../../common/api'
import TableExpand from '../components/tableExpand.vue'

export default {
    components: {
        TableExpand
    },
    methods: {
        async initData(type) {
            await this.getUserList(type)
            await this.filterTableData(this.data)
        },
        getUserList(type) {
            return new Promise((resolve, reject) => {
                api.getUserList({
                    condition: this.curSearchField === 'sex' && this.curSearchTxt === '-1' ? '' : this.curSearchTxt,
                    queryField: this.curSearchField,
                    deptId: type ? [] : [(this.curDeptInfo || {}).id].filter(Boolean),
                    pageNum: this.curPage,
                    pageSize: this.pageSize
                }).then((res) => {
                    if (res.resultCode === 0) {
                        // eslint-disable-next-line array-callback-return
                        this.data = res.data
                        resolve(res.data)
                    }
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        batchRemoveUser(data) {
            api.batchRemoveUser(data).then((res) => {
                console.log(res)
                if (res.resultCode === 0) {
                    this.$Message.success('删除成功!')
                    this.curChoiceUser = []
                    this.initData()
                } else {
                    this.$Message.error(res.resultMessage)
                }
            }).catch((err) => {
                this.$Message.error(err.resultMessage)
            })
        },
        getUserAttrList() {
            api.getUserAttrList({
                pageNum: 1,
                pageSize: 0
            }).then((res) => {
                utils.resSucFactory(res, () => {
                    this.userAttrObj.attrList = res.data.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        code: item.code,
                        enable: !(!item.enable || Number(item.enable) === -1),
                        isDisplay: !(!item.isDisplay || Number(item.isDisplay) === -1),
                        required: !(!item.required || Number(item.required) === -1),
                        isOnly: !(!item.isOnly || Number(item.isOnly) === -1),
                        matchRule: item.matchRule,
                        type: item.type,
                        value: ''
                    }))
                    this.getShowSignature(this.userAttrObj.attrList)
                    this.createUserObj.attrList = JSON.parse(JSON.stringify(this.userAttrObj.attrList))
                })
            })
        },
        createColumns(data) {
            const enableData = []
            const displayField = []
            data.forEach((item) => {
                if (item.code === 'deptName' && this.isShowSearchResult) {
                    displayField.push({
                        name: '所在机构',
                        code: 'deptName'
                    })
                }
                if (item.enable === '0') {
                    enableData.push(item)
                }
                if (item.enable === '0' && item.isDisplay === '0') {
                    displayField.push(item)
                }
            })
            const defaultField = [{
                name: '用户名',
                code: 'loginName'
            }, {
                name: '角色',
                code: 'roleName'
            }]
            this.tableExpend = displayField.concat({
                name: '创建时间',
                code: 'createTime'
            })
            this.displayField = defaultField.concat(enableData)
        },
        defaultColumns() {
            this.columns = [
                {
                    type: 'expand',
                    width: 50,
                    render: (h, params) => h(TableExpand, {
                        props: {
                            row: params.row,
                            fields: this.tableExpend
                        }
                    })
                },
                {
                    type: 'selection',
                    width: '60'
                },
                {
                    title: '用户名',
                    key: 'loginName',
                    width: '120'
                },
                {
                    title: '角色',
                    key: 'roleName',
                    slot: 'roleName'
                }, {
                    title: '操作',
                    slot: 'action',
                    width: '200'
                }
            ]
            if (this.isShowSearchResult) {
                this.columns.splice(3, 0, {
                    title: '所属机构',
                    key: 'deptName'
                })
            }
            this.displayField = [{
                name: '用户名',
                code: 'loginName'
            }, {
                name: '角色',
                code: 'roleName'
            }, {
                name: '所属机构',
                code: 'deptName'
            }]
        },
        getDisplayField() {
            api.getDisplayField().then((res) => {
                utils.resSucFactory(res, () => {
                    const status = res.data.every((item) => !item.enable || item.enable === '-1')
                    this.defaultColumns()
                    if (!status) {
                        this.createColumns(res.data)
                    } else {
                        this.tableExpend = [{
                            name: '创建时间',
                            code: 'createTime'
                        }]
                    }
                })
            })
        }
    }
}
